import React, { useState, useRef, useEffect, Fragment, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Heart, Bookmark, Home, MapPin, UserPlus, ShieldCheck } from "lucide-react";

const SliderMenu = ({ onClose }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const menuItems = [
        // { icon: Heart, label: "My Posts", path: "/neighborhood/posted" },
        // { icon: Bookmark, label: "My Saved", path: "/neighborhood/saved" },
        // { icon: Home, label: "My Neighbors", path: "/neighborhood/your-neighbor" },
        { icon: MapPin, label: "My Location", path: "/neighborhood/location" },
        { icon: UserPlus, label: "Invite Neighbors", path: "/neighborhood/invite" },
        { icon: ShieldCheck, label: "Neighborhood Guidelines", path: "/neighborhood/guidelines" },
    ];

    const handleClickOutside = useCallback((event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setIsOpen(false);
            onClose();
        }
    }, [onClose]);

    useEffect(() => {
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, handleClickOutside]);

    useEffect(() => {
        setIsOpen(true);
    }, []);

    return (
        <Fragment>
            <AnimatePresence>
                {isOpen && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 z-10">
                        <motion.div
                            ref={menuRef}
                            initial={{ x: "100%" }}
                            animate={{ x: 0 }}
                            exit={{ x: "100%" }}
                            transition={{ type: "tween", duration: 0.3 }}
                            className="absolute top-0 right-0 w-3/5 h-full bg-white  dark:bg-[#1E1D21] shadow-lg z-30"
                        >
                            <p className="text-[14px] mt-5 px-3 py-2 font-bold text-black dark:text-white border-b border-gray-200 dark:border-gray-700">Menu</p>
                            {menuItems.map((item, index) => {
                                const Icon = item.icon;
                                const isActive = location.pathname === item.path;
                                return (
                                    <div
                                        key={index}
                                        className={`flex items-center gap-x-3 px-3 py-0.5 w-full border-b border-gray-200 dark:border-gray-800/50 cursor-pointer ${
                                            isActive 
                                                ? "bg-[#BDE6FF]/50 dark:bg-gray-800 text-[#38aef8]" 
                                                : "text-black hover:text-[#38aef8] dark:text-gray-400 dark:hover:text-white"
                                        }`}
                                        onClick={() => navigate(item.path)}
                                    >
                                        <Icon className="w-4 h-4" />
                                        <p className="text-[13px] py-2">{item.label}</p>
                                    </div>
                                );
                            })}
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </Fragment>
    );
};

export default SliderMenu;